/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Is_TitleInputs */

const fr_help_is_title = /** @type {(inputs: Help_Is_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est`)
};

const en_help_is_title = /** @type {(inputs: Help_Is_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is`)
};

/**
* | output |
* | --- |
* | "It is" |
*
* @param {Help_Is_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_is_title = /** @type {((inputs?: Help_Is_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Is_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_is_title(inputs)
	return en_help_is_title(inputs)
});